const routeAuth = [
  {
    path: '/login',
    name: 'LoginPage',
    component: () => import('../pages/auth/LoginPage'), // Login
    meta: {
      layout: 'BlankLayout',
    },
  },
  {
    path: '/loginstg',
    name: 'LoginV2',
    component: () => import('../pages/auth/LoginPage'),
    meta: {
      layout: 'BlankLayout',
    },
  },
  {
    path: '/logout',
    name: 'Logout',
    component: () => import('../pages/auth/LoginPage'),
    meta: {
      layout: 'BlankLayout',
      logout: true,
    },
  },
  {
    path: '/logoutstg',
    name: 'Logout',
    component: () => import('../pages/auth/LoginPage'),
    meta: {
      layout: 'BlankLayout',
      logout: true,
    },
  },
];

export default routeAuth;
